import { render, staticRenderFns } from "./serial_code_create.vue?vue&type=template&id=86d500a8&scoped=true"
import script from "./serial_code_create.vue?vue&type=script&lang=ts"
export * from "./serial_code_create.vue?vue&type=script&lang=ts"
import style0 from "./serial_code_create.vue?vue&type=style&index=0&id=86d500a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d500a8",
  null
  
)

export default component.exports